<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.品牌详情类型编辑')}}</span>
      </div>
      <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont" >&#xe600;</i>
              {{$t('message.返回')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="!isEditMode && !isInit"
          >
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont" >&#xe618;</i>
              {{$t('message.修改')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="isEditMode"
          >
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont" >&#xe769;</i>
              {{$t('message.保存')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="!isInit"
          >
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont" >&#xe667;</i>
              {{$t('message.刷新')}}
            </el-button>
          </el-link>
        </div>
      </div>
      </div>
      <div class="grid-content content-margin">
        <el-divider></el-divider>
        <table class="simpleRow">
          <tr v-if="detailtypeid > 0">
            <td>
              <span class="simpleLabel">{{$t('message.详情类型ID')}}</span>
            </td>
            <td >
              <el-input
              v-model="detailtypeid"
              readonly
              size="mini"
              placeholder="">
                <!-- <template slot="prepend">详情类型ID</template> -->
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.详情类型名称')}}</span>
            </td>
            <td >
              <el-input
              :readonly="!isEditMode"
              v-model="name"
              size="mini"
              maxlength="10"
              :placeholder="$t('message.输入10个以内汉字')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.优先级排序')}}'</span>
            </td>
            <td >
              <el-input-number :min="0" :disabled="!isEditMode" size="mini" v-model="sort"></el-input-number>
            </td>
          </tr>
          <tr v-if="detailtypeid > 0">
            <td>
              <span class="simpleLabel">{{$t('message.创建日期')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="createdate"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="detailtypeid > 0">
            <td>
              <span class="simpleLabel">{{$t('message.创建人')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="createid"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="detailtypeid > 0">
            <td>
              <span class="simpleLabel">{{$t('message.更新日期')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="editdate"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="detailtypeid > 0">
            <td>
              <span class="simpleLabel">{{$t('message.更新人')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="editid"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
        </table>
      </div>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {topfixfunc} from "@/utils/topFix";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "BrandTypeDetail",
  data() {
    return {
      appid: 0,
      detailtypeid: 0,
      name: "",
      sort: 0,
      createdate: "",
      createid: "",
      editdate: "",
      editid: "",
      isEditMode: true,
      isInit: true,
    };
  },
  mounted: function () {
    topfixfunc()
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    doSave() {
      if (this.name == "") {
        this.$message({
          type: "error",
          message: this.$t('message.详情类型名称不能为空'),
        });
        return;
      }
      this.isEditMode = false;
      if (this.isInit)
      rejecthttp(true,'post',"/manage/brand/addbrandtypeinfo",{
            appid: this.appid,
            info: {
              appid: this.appid,
              detailtypeid: this.detailtypeid,
              name: this.name,
              sort: this.sort,
              createdate: "2021-07-21T07:17:22.619Z",
              createid: 0,
              editdate: "2021-07-21T07:17:22.619Z",
              editid: 0,
            },
          },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            //  this.successMsgBox(doc.data.Message);
            //   this.openDirectory(
            //     this.currentData ? this.currentData.directoryID : "0"
            //   );
            }
            });
        // this.$http
        //   .post("/manage/brand/addbrandtypeinfo", {
        //     appid: this.appid,
        //     info: {
        //       appid: this.appid,
        //       detailtypeid: this.detailtypeid,
        //       name: this.name,
        //       sort: this.sort,
        //       createdate: "2021-07-21T07:17:22.619Z",
        //       createid: 0,
        //       editdate: "2021-07-21T07:17:22.619Z",
        //       editid: 0,
        //     },
        //   })
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.$message({
        //         type: "success",
        //         message: doc.data.Message,
        //       });
        //       this.$router.go(-1); //返回上一层
        //     }
        //   });
      else {
        rejecthttp(true,'post',"/manage/brand/updatebrandtypeinfo",{
            appid: this.appid,
            info: {
              appid: this.appid,
              detailtypeid: this.detailtypeid,
              name: this.name,
              sort: this.sort,
              createdate: "2021-07-21T07:17:22.619Z",
              createid: 0,
              editdate: "2021-07-21T07:17:22.619Z",
              editid: 0,
            },
          },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            //  this.successMsgBox(doc.data.Message);
            //   this.openDirectory(
            //     this.currentData ? this.currentData.directoryID : "0"
            //   );
            }
            });
        // this.$http
        //   .post("/manage/brand/updatebrandtypeinfo", {
        //     appid: this.appid,
        //     info: {
        //       appid: this.appid,
        //       detailtypeid: this.detailtypeid,
        //       name: this.name,
        //       sort: this.sort,
        //       createdate: "2021-07-21T07:17:22.619Z",
        //       createid: 0,
        //       editdate: "2021-07-21T07:17:22.619Z",
        //       editid: 0,
        //     },
        //   })
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.$message({
        //         type: "success",
        //         message: doc.data.Message,
        //       });
        //     }
        //   });
      }
    },
    refresh() {
      if (!this.detailtypeid) {
        return;
      }
      rejecthttp(true,'get',"/manage/brand/getbrandtypeinfo",{
            appid: this.appid,
            brandid: this.detailtypeid,
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            console.log(doc.data);
            this.detailtypeid = doc.data.data.detailtypeid;
            this.name = doc.data.data.name;
            this.sort = doc.data.data.sort;
            this.createdate = commonUtil.formatDate(doc.data.data.createdate);
            this.createid = doc.data.data.createid;
            this.editdate = commonUtil.formatDate(doc.data.data.editdate);
            this.editid = doc.data.data.editid;
            }
            });
      // this.$http
      //   .get("/manage/brand/getbrandtypeinfo", {
      //     params: {
      //       appid: this.appid,
      //       brandid: this.detailtypeid,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       console.log(doc.data);
      //       this.detailtypeid = doc.data.data.detailtypeid;
      //       this.name = doc.data.data.name;
      //       this.sort = doc.data.data.sort;
      //       this.createdate = commonUtil.formatDate(doc.data.data.createdate);
      //       this.createid = doc.data.data.createid;
      //       this.editdate = commonUtil.formatDate(doc.data.data.editdate);
      //       this.editid = doc.data.data.editid;
      //     }
      //   });
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.detailtypeid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
    user-select: text!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/brands/BrandTypeDetail.vue